import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import css from '../assets/css.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import tensorflow from '../assets/tensorflow.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';

import bolt from '../assets/bolt.png';
import skype from '../assets/skype.png';
import spotify from '../assets/spotify.png';

export default {
  email,
  mobile,
  css,
  flutter,
  tensorflow,
  git,
  html,
  javascript,
  node,
  python,
  react,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  bolt,
  skype,
  spotify,
};